<template>
  <div class="swatches">
    <template v-for="swatch in swatches">
      <div
        v-tippy="{
          placement: 'top',
          theme: 'dark',
          interactive: false,
          boundary: 'window',
        }"
        :content="swatch.name"
        class="swatch"
        :class="{active: swatch.value === value}"
        @click="emit(swatch)"
        :style="{'--currentValue': swatch.value}"
        :key="swatch.name + swatch.value"
      ></div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'Swatches',
  props: {
    swatches: {
      type: Array,
      default() {
        return [];
      },
    },
    value: String,
  },
  methods: {
    emit(swatch) {
      this.$emit('input', swatch.value);
    },
  },
};
</script>

<style>
.swatches {
  display: flex;
  flex-wrap: wrap;
}

.swatch {
  position: relative;
  flex-basis: calc(16.666% - 10px);
  margin: 4px;
  box-sizing: border-box;
  background: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 2"><path fill="white" d="M1,0H2V1H1V0ZM0,1H1V2H0V1Z"/><path fill="gray" d="M0,0H1V1H0V0ZM1,1H2V2H1V1Z"/></svg>');
  background-size: 6px;

  @apply border
    rounded
    border-solid
    border-dull
    overflow-hidden;
}

.swatch.active {
  @apply border
    border-solid
    border-primary;
}

.swatch::before {
  content: '';
  display: block;
  padding-top: 100%;
  background: var(--currentValue);
}
</style>
